import { render, staticRenderFns } from "./protocoloDestinatarios.vue?vue&type=template&id=39a2a484&scoped=true&"
import script from "./protocoloDestinatarios.vue?vue&type=script&lang=js&"
export * from "./protocoloDestinatarios.vue?vue&type=script&lang=js&"
import style0 from "./protocoloDestinatarios.vue?vue&type=style&index=0&id=39a2a484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a2a484",
  null
  
)

export default component.exports